/* Lo que sabe RRHH que es cuenta y no consulta.
 *
 * ── LA ANTIGÜEDAD SE CALCULA Y NO SE LEE ────────────────────────────────────
 *
 * El export de sueldos trae una columna «Antigüedad», y no se usa: quedó
 * congelada el día que se generó el archivo. Un dato así empieza bien y
 * envejece mal —un mes de error por mes— sin que nada lo señale, que es la
 * peor forma de estar mal. Con la fecha de ingreso y el día de hoy la cuenta
 * sale sola y no se puede desactualizar.
 *
 * ── SALE DE `ingreso_computable` Y NO DEL REAL ──────────────────────────────
 *
 * Son dos fechas distintas y la que importa es la reconocida: para el que se
 * fue y volvió, o el que pasó de TransAmerica a TCC, la antigüedad que le
 * corresponde no arranca el día que firmó el último contrato. Hoy difieren en
 * una persona de 292 — y es el campo que hace bien la cuenta el día que no sea
 * una.
 *
 * ── ESTÁ ACÁ Y NO EN LA PANTALLA porque la miran dos ────────────────────────
 *
 * La ficha de la persona y el listado de la nómina. Escrita en las dos, el día
 * que se corrija el redondeo en una, la misma persona tendría dos antigüedades
 * distintas según desde dónde se la mire — y no hay forma de notarlo.
 */

import { mediodiaHoyAr } from "./fechaAr";

/* Los meses cumplidos entre una fecha y hoy. `null` si la fecha no sirve.
 *
 * CUMPLIDOS, no redondeados: el que entró el 30 del mes pasado tiene cero
 * meses hasta el 30 de éste. Redondear para arriba le regalaría antigüedad, y
 * es un número del que después se habla en una paritaria.
 */
export function mesesDesde(desde, hoy = mediodiaHoyAr()) {
  if (!desde) return null;
  // Mediodía y no medianoche: con `T00:00:00` un huso al oeste de UTC corre la
  // fecha un día para atrás, y el que entró un día 1 pasa a figurar entrando
  // el último del mes anterior.
  const d = new Date(String(desde).slice(0, 10) + "T12:00:00");
  if (Number.isNaN(d.getTime())) return null;
  let meses =
    (hoy.getFullYear() - d.getFullYear()) * 12 + (hoy.getMonth() - d.getMonth());
  if (hoy.getDate() < d.getDate()) meses -= 1;
  // Una fecha de ingreso futura no es antigüedad negativa: es un dato mal
  // cargado, y «-3 meses» en una ficha se lee como que la pantalla falló.
  return meses < 0 ? null : meses;
}

/* La antigüedad escrita. `null` si no se puede calcular.
 *
 * DOS FORMAS PORQUE HAY DOS LUGARES: en la ficha hay una línea entera para
 * ella y se escribe completa; en la tabla comparte celda con la fecha de
 * ingreso, y «3 años y 2 meses» ahí empuja la columna al scroll horizontal.
 * Es el mismo número dicho en dos anchos, no dos cuentas.
 */
export function antiguedad(desde, { corto = false, hoy = mediodiaHoyAr() } = {}) {
  const meses = mesesDesde(desde, hoy);
  if (meses === null) return null;
  const a = Math.floor(meses / 12);
  const m = meses % 12;
  if (corto) {
    if (!a) return `${m} m`;
    return m ? `${a} a ${m} m` : `${a} a`;
  }
  if (!a) return `${m} ${m === 1 ? "mes" : "meses"}`;
  return (
    `${a} ${a === 1 ? "año" : "años"}` +
    (m ? ` y ${m} ${m === 1 ? "mes" : "meses"}` : "")
  );
}
